// src/pages/Public/ResendVerification.js
import { useState } from 'react';
import axios from '../../utils/axios';
import { Link } from 'react-router-dom';
import './ResendVerification.css';

function ResendVerification() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post('/auth/resend-verification', { email });
      setMessage(response.data.msg);
    } catch (err) {
      setError(err.response?.data?.msg || 'Bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="resend-verification-page">
      <div className="resend-container">
        <h1>Doğrulama Emaili Yeniden Gönder</h1>
        <p>Email adresinizi girin, size yeni bir doğrulama linki gönderelim.</p>

        {message && <div className="success-message">{message}</div>}
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Adresi</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="ornek@email.com"
            />
          </div>

          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? 'Gönderiliyor...' : 'Doğrulama Emaili Gönder'}
          </button>
        </form>

        <div className="links">
          <Link to="/login">Giriş sayfasına dön</Link>
        </div>
      </div>
    </div>
  );
}

export default ResendVerification;